import extractId from "~/components/forms/utilities/extractId";
import extractAction from "~/components/forms/utilities/extractAction";

export default function applySetter(value, fieldName) {
  const action = extractAction.call(this);
  const id = extractId.call(this);
  const field = fieldName || this.fieldName;

  if (action) {
    this.$store.dispatch(action, {
      id,
      field,
      value,
      index: this.index,
    });
  } else {
    this.item[field] = value;
  }
}
